import { c as _c } from "react/compiler-runtime";
import OptimizedImage from '@/components/OptimizedImage';
import IconPicture from '@/components/assets/icon_picture.svg';
import IconVideo from '@/components/assets/icon_video.svg';
import ProcessingOverlay from '@/components/ProcessingOverlay';
import { useDraggingScroll } from '@/hooks/useDraggingScroll';
import { useScrollable } from '@/hooks/useScrollable';
import { cn } from '@/lib/utils';
import { Asset } from '@/types/asset';
type MediaGalleryProps = {
  assets: Asset[];
};
function MediaGallery(t0) {
  const $ = _c(14);
  const {
    assets
  } = t0;
  const {
    containerRef,
    canScrollLeft,
    canScrollRight
  } = useScrollable();
  const {
    bind,
    disableDrag,
    onMouseDown,
    onMouseUp
  } = useDraggingScroll(containerRef);
  let t1;
  if ($[0] !== bind) {
    t1 = bind();
    $[0] = bind;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !disableDrag && (canScrollLeft || canScrollRight);
  const t3 = !disableDrag && (canScrollLeft || canScrollRight);
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = cn("no-scrollbar flex w-full gap-4 overflow-x-auto scroll-smooth md:gap-6 lg:flex-wrap", {
      "active:cursor-grabbing": t2,
      "cursor-grab": t3
    });
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== assets) {
    t5 = assets.map(_temp);
    $[5] = assets;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== containerRef || $[8] !== onMouseDown || $[9] !== onMouseUp || $[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div {...t1} ref={containerRef} className={t4} onMouseDown={onMouseDown} onMouseUp={onMouseUp}>{t5}</div>;
    $[7] = containerRef;
    $[8] = onMouseDown;
    $[9] = onMouseUp;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp(asset, index) {
  return <div key={index} className="1.5xl:max-w-[306px] relative aspect-200/117 min-h-[117px] md:aspect-306/180 md:min-h-[180px] md:max-w-[306px] lg:max-w-[290px]">{asset.image?.url ? <><OptimizedImage src={asset.image.url} alt="cover" fill={true} sizes="(max-width: 768px) 200px, (max-width: 1440px) 306px, 25vw" className="rounded-2xl object-cover" /><IconPicture className="absolute bottom-2 left-2 z-interactive size-7" /></> : asset.video?.url ? <><video src={asset.video.url} className="size-full rounded-2xl object-cover" controls={true} playsInline={true} muted={true} /><IconVideo className="fill-vive-primary-20 pointer-events-none absolute bottom-2 left-2 z-interactive size-7" />{!asset.video.isConverted && <ProcessingOverlay animate={true} className="pointer-events-none absolute top-0 left-0" />}</> : asset.video?.coverImage ? <><OptimizedImage src={asset.video.coverImage} alt="cover" fill={true} sizes="(max-width: 768px) 200px, (max-width: 1440px) 306px, 25vw" className="rounded-2xl object-cover" /><IconVideo className="fill-vive-primary-20 pointer-events-none absolute bottom-2 left-2 z-interactive size-7" /><ProcessingOverlay animate={true} className="pointer-events-none absolute top-0 left-0" /></> : <ProcessingOverlay animate={true} />}</div>;
}
export default MediaGallery;